enum NavigationBarMessage {
  Shown = "Shown",
  Hidden = "Hidden",
}

export enum ScormVersion {
  SCORM_1_2 = "1_2",
  SCORM_2004_3 = "2004_3",
}

export const VersionMap = {
  [ScormVersion.SCORM_1_2]: "SCORM 1.2",
  [ScormVersion.SCORM_2004_3]: "SCORM 2004 3rd Edition",
};

export enum LMS {
  GenericLMS = "GenericLMS",
  Litmos = "Litmos",
  Docebo = "Docebo",
  Saba = "Saba",
  SapLso = "SapLso",
  SumTotal = "SumTotal",
  SuccessFactors = "SuccessFactors",
}

export const LMSMap = {
  [LMS.GenericLMS]: "Generic LMS",
  [LMS.Litmos]: "Litmos",
  [LMS.Docebo]: "Docebo",
  [LMS.Saba]: "SABA",
  [LMS.SapLso]: "SAP LSO",
  [LMS.SumTotal]: "Sum Total",
  [LMS.SuccessFactors]: "SuccessFactors",
};

export const navigationBarMsg = (hideLmsNavbar: boolean): NavigationBarMessage =>
  hideLmsNavbar ? NavigationBarMessage.Hidden : NavigationBarMessage.Shown;

export const scormVersionMsg = (version: string): string => {
  return VersionMap[version] || "SCORM Unknown version";
};

export const lmsNameMsg = (name: string): string => {
  return LMSMap[name] || "Unknown LMS";
};
